import Api from "./Api";
import { setAdminData } from "../redux/slices/AdminSlice";

export const fetchAndSetAdminData = async (token, dispatch) => {
  try {
    const response = await Api.getAdminInfo(token);
    if (response.data.status) {
      const adminData = response.data.data;
      dispatch(
        setAdminData({
          firstName: adminData.firstName,
          lastName: adminData.lastName,
          email: adminData.email,
          image: adminData.image,
        })
      );
      return adminData;
    }
  } catch (error) {
    console.error("Failed to fetch admin data:", error);
    return null;
  }
};
